import { mergeClasses } from '@fluentui/react-components';

import CardBackgroundContent from 'src/components/atoms/card-background-content/CardBackgroundContent';
import CardLayoutContainer from 'src/components/molecules/card-layout-container/CardLayoutContainer';
import { STEP_BATTLE_BACKGROUND_IMAGE } from 'src/utils/constants';
import { BaseCardLayoutProps } from 'src/ui-models/cardLayout';
import CardBackgroundHeaderBlock from 'src/components/molecules/card-background-header-block/CardBackgroundHeaderBlock';
import { useCardStepBattleLayoutStyles } from './CardStepBattleLayout.styles';

type CardStepBattleLayoutProps = BaseCardLayoutProps;

const CardStepBattleLayout: React.FC<CardStepBattleLayoutProps> = ({
  headline, body, className,
}) => {
  const styles = useCardStepBattleLayoutStyles();
  const sectionLabel = 'The';
  const title = 'INVITATIONAL';
  const caption = 'Team Step Challenge';
  const backgroundStyle: React.CSSProperties = { backgroundImage: `url(${STEP_BATTLE_BACKGROUND_IMAGE})` };

  const cardHeader = (
    <CardBackgroundHeaderBlock
      sectionLabel={sectionLabel}
      title={title}
      caption={caption}
    />
  );

  return (
    <CardLayoutContainer
      className={mergeClasses('card-step-battle-layout', styles.stepBattleImageBackground, className)}
      style={backgroundStyle}
      header={cardHeader}
      headerClassName={styles.header}
    >
      <CardBackgroundContent headline={headline} body={body} />
    </CardLayoutContainer>
  );
};

export default CardStepBattleLayout;
